<template>
  <div id="is-empty" class="empty-container">
    <Error :type="type" :desc="desc"/>
  </div>
</template>

<script>
import Error from "@/components/Error";
import store from '@/store'
export default {
  name: "Empty",
  components: {
    Error
  },
  props:["type","desc"],
  mounted() {
    store.commit("toggleTabbarShow", false);
  }
}
</script>

<style scoped>
.empty-container{
  height:100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>